import React from "react";
import { useGlobalValue } from "colbi_web_ui/lib/state/GlobalProvider";
import { SovosButton, SovosBox, SovosChipFilter } from "mosaic-react";
import { BorderColor, ModeEdit } from "mosaic-react-icons";
import { useTheme } from "mosaic-react/styles";

const HeaderEditMode = (props) => {
    const { editMode, setEditMode, onClickSave, params, list: datagridList, rawDataEdit } = props;
    const { importId } = params;
    const theme = useTheme();
    const { i18n } = useGlobalValue();

    return (
        <SovosBox sx={{ display: "flex", flex: 1, alignItems: "center", marginLeft: "10px" }}>
            {editMode && (
                <SovosBox sx={{ justifyContent: "flex-start" }}>
                    <SovosChipFilter
                        sx={{
                            fontSize: "small",
                            height: 25,
                            marginLeft: 1,
                            background: theme.palette.error.light,
                            padding: "6px",
                        }}
                        icon={<ModeEdit fontSize={"small"} />}
                        label={i18n`Edit Mode`}
                    />
                </SovosBox>
            )}
            <SovosBox sx={{ display: "flex", justifyContent: "flex-end", flex: 1 }}>
                {!editMode && (
                    <SovosButton
                        sx={{
                            marginRight: "2px",
                        }}
                        disabled={!rawDataEdit || !datagridList?.length || importId !== "full"}
                        variant={"text"}
                        startIcon={<BorderColor />}
                        onClick={() => {
                            setEditMode(true);
                        }}
                        tooltipText={
                            !rawDataEdit || !datagridList?.length || importId !== "full"
                                ? i18n`Edit mode is only available in full mode. Legal files cannot be edited`
                                : i18n`Activate Edit Mode`
                        }
                    >
                        {i18n`Edit Mode`}
                    </SovosButton>
                )}
                {editMode && <SovosButton onClick={onClickSave}>{i18n`Save`}</SovosButton>}
                {editMode && (
                    <SovosButton
                        variant={"outlined"}
                        sx={{
                            marginLeft: "2px",
                        }}
                        onClick={(e) => {
                            setEditMode(false);
                        }}
                    >
                        {i18n`Cancel`}
                    </SovosButton>
                )}
            </SovosBox>
        </SovosBox>
    );
};

export default HeaderEditMode;
